/* eslint-disable @typescript-eslint/no-explicit-any */
import * as yup from 'yup';

import {
  LC_PAGE_COMPETENCY_CHAR_LIMIT,
  LC_PAGE_SUBJECT_CHAR_LIMIT,
} from '@lessonPlanner/constants';

export const subject = yup
  .string()
  .required('Please enter a subject')
  .test(
    'len',
    'You have reached the character limit',
    (val: any) => val.length <= LC_PAGE_SUBJECT_CHAR_LIMIT,
  );

export const gradeLevel = yup.string().required('Please select a grade level');

export const competency = yup
  .string()
  .required('Please enter competency')
  .test(
    'len',
    'You have reached the character limit',
    (val: any) => val.length <= LC_PAGE_COMPETENCY_CHAR_LIMIT,
  );

export const language = yup.string().required('Please select a translation');

export const curriculumFramework = yup
  .string()
  .required('Please enter the framework');

export const specificStandards = yup
  .string()
  .required('Please enter the standard');

export const objectives = yup
  .string()
  .required('Please enter the benchmark/outcomes');

export const cognitiveVerbs = yup
  .mixed()
  .transform((value) => (typeof value === 'string' ? JSON.parse(value) : value))
  .test('is-array', 'Must be an array', (value) => Array.isArray(value));

export const affectiveVerbs = yup
  .mixed()
  .transform((value) => (typeof value === 'string' ? JSON.parse(value) : value))
  .test('is-array', 'Must be an array', (value) => Array.isArray(value));

export const psychomotorVerbs = yup
  .mixed()
  .transform((value) => (typeof value === 'string' ? JSON.parse(value) : value))
  .test('is-array', 'Must be an array', (value) => Array.isArray(value));
